import React, { useMemo } from "react";
import PropTypes from "prop-types";
import { useApp } from "../../../context/AppState";
import { getBrandAttributionDisplay } from "../../../../shared/brand-attribution.js";
import { buildFontFamilyStyle } from "../../../helper";
import { getSectionBlockCss } from "../../../utils/sectionBlockCss";
import {
  getLiveWatermarkHref,
  isWatermarkEnabled,
  resolveWatermarkDisplay,
} from "../../../utils/popup-watermark";
import styles from "./AiBrandAttribution.module.css";

export default function AiBrandAttribution({
  section,
  forceShowBadge = false,
  forceShowAttribution = false,
}) {
  const { appState, isMobile } = useApp();
  const display = useMemo(
    () => getBrandAttributionDisplay(section),
    [section]
  );
  const typographyStyle = useMemo(() => {
    if (!section) return {};
    const css = getSectionBlockCss(section, isMobile);
    return buildFontFamilyStyle(css.fontFamily);
  }, [section, isMobile]);
  const watermarkConfig = useMemo(() => resolveWatermarkDisplay(), []);

  const linkUrl =
    display.linkUrl || watermarkConfig.liveUrl || "https://weupsell.com";
  const liveHref = getLiveWatermarkHref();

  const watermarkEnabled =
    forceShowAttribution ||
    appState?.is_preview_mode ||
    isWatermarkEnabled(appState?.watermark, appState?.shop);

  const showBadge =
    display.showBrandBadge === true &&
    (forceShowBadge || watermarkEnabled);

  const onLinkClick = (e) => {
    e.stopPropagation();
  };

  if (!watermarkEnabled) {
    return null;
  }

  return (
    <div
      className={styles.wrap}
      data-weupsell-brand-attribution="true"
      style={typographyStyle}
    >
      <p className={styles.attribution}>
        {display.prefix ? (
          <span className={styles.prefix}>{display.prefix} </span>
        ) : null}
        <a
          className={styles.brandLink}
          href={linkUrl}
          target="_blank"
          rel="noopener noreferrer"
          onClick={onLinkClick}
        >
          {display.linkText || "WeUpsell"}
        </a>
        {display.suffix ? (
          <span className={styles.suffix}> {display.suffix}</span>
        ) : null}
      </p>

      {showBadge ? (
        <a
          className={styles.badge}
          href={liveHref}
          target="_blank"
          rel="noopener noreferrer"
          title="WeUpsell — AI upsell for Shopify"
          onClick={onLinkClick}
          data-weupsell-popup-watermark="inline"
        >
          {display.badgeShowLogo !== false && watermarkConfig.logoUrl ? (
            <img
              src={watermarkConfig.logoUrl}
              alt=""
              width={16}
              height={16}
              className={styles.badgeLogo}
            />
          ) : null}
          <span className={styles.badgeText}>
            {display.badgeText || watermarkConfig.text || "WeUpsell"}
          </span>
        </a>
      ) : null}
    </div>
  );
}

AiBrandAttribution.propTypes = {
  section: PropTypes.object,
  forceShowBadge: PropTypes.bool,
  forceShowAttribution: PropTypes.bool,
};
